import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import axios from 'axios'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'


import {
	ACCESS_TOKEN,
	CANVAS_URL
} from '@/Variables';

import {
	AuthModule
} from './modules/AuthModule';
import {
	DocumentStore
} from './stores/DocumentStore';
import {
	ForumModule
} from './stores/ForumModule';
import {
	UrlModule
} from './modules/UrlModule';
import {
	LoaderModule
} from './modules/LoaderModule';
import {
	ChatModule
} from './modules/ChatModule';
import {
	SidebarStore
} from './stores/SidebarStore';
import {
	ProcessModule
} from './modules/ProcessModule';
import {
	CalendarStore
} from './stores/CalendarStore';
import {
	JournalModule
} from './modules/JournalModule';
import {
	SearchModule
} from './modules/SearchModule'
import {
	NotificationsModule
} from './modules/NotificationsModule';
import {
	LastLessonModule
} from './modules/LastLessonModule'

import Board from '@/models/Board'
import Note from '@/models/Note'
import Media from '@/models/Media'
import Comment from '@/models/Comment'
import User from '@/models/User'
import BoardUser from '@/models/BoardUser'
import {MentorModule} from "@/modules/MentorModule";
const database = new VuexORM.Database()
database.register(Board)
database.register(Note)
database.register(Media)
database.register(Comment)
database.register(User)
database.register(BoardUser)

let accessToken = ACCESS_TOKEN;
if (ACCESS_TOKEN == null) {
	accessToken = '';
}
let additionalHeaders = {}
let defaultHeaders = {
	'X-Requested-With': 'XMLHttpRequest',
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};

if (accessToken.length > 0) {
	defaultHeaders['Authorization'] = 'Bearer ' + accessToken;
}

Vue.use(Vuex)
VuexORM.use(VuexORMAxios, {
	axios,
	baseURL: CANVAS_URL,
	headers: {
		...defaultHeaders,
		...additionalHeaders
	}
})
const vuexAuth = new VuexPersistence({
	modules: ['auth']
})

export const Store = new Vuex.Store({
	modules: {
		auth: AuthModule,
		url: UrlModule,
		loader: LoaderModule,
		documentStore: DocumentStore,
		forum: ForumModule,
		chat: ChatModule,
		sidebar: SidebarStore,
		process: ProcessModule,
		calendar: CalendarStore,
		journal: JournalModule,
		notifications: NotificationsModule,
		search: SearchModule,
		lastLesson: LastLessonModule,
		mentor:MentorModule
	},
	plugins: [vuexAuth.plugin, VuexORM.install(database)]


});